import { render } from "./CalendarSidebarDates.vue?vue&type=template&id=dada7660"
import script from "./CalendarSidebarDates.vue?vue&type=script&lang=js"
export * from "./CalendarSidebarDates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__